import Backbone from 'backbone'
import ConjunctionEditor from './conjunction-editor'
import template from './conditional-statement-editor.hbs'
import i18n from 'scoreboard/components/i18n'
import icon from 'scoreboard/components/icon'

const ConditionalStatementEditor = Backbone.View.extend(/** @lends {ConditionalStatementEditor} */{

	className: 'conditional-statement-editor',

	/**
	 * An editor for a single conditional statement. It differs from the
	 * logician in that it edits a single conditional statement instead of
	 * the multiple conditional statements that the logician can edit. (#46581)
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Number} [options.index] the index of this conditional statement
	 *
	 * @param {ConditionalStatement} [options.statement] an existing conditional
	 * statement to be rendered
	 *
	 * @param {Function} options.conditionEditorCreator a Function that returns
	 * a new instance of an editor for a Condition. The Condition may be new or
	 * existing
	 *
	 * @param {Function} options.consequencesEditorCreator a Function that
	 * returns a new instance of an editor that can be used to create and edit
	 * Consequences
	 */
	initialize: function(options = {}) {
		this.options = options
	},

	render: function() {
		this.$el.html(template())
		this.renderTitle(this.options.index)
		this.renderConjunctionEditor()
		this.renderConsequencesEditor()
		this.$el.data('view', this)
		return this
	},

	renderTitle: function(index) {
		let key = 'logic.elseIf'
		if (index === 0) {
			key = 'common.if'
		}
		this.$('.title').html(icon('collapsed') + i18n.get(key))
	},

	renderConjunctionEditor: function() {
		// for tests
		if (!this.options.conditionEditorCreator) return

		this.conjunctionEditor = new ConjunctionEditor({
			formView: this.options.formView,
			conjunction: this.options.statement,
			conditionEditorCreator: this.options.conditionEditorCreator,
			nested: true
		})
		this.$('.conjunction-editor-container').append(this.conjunctionEditor.el)
		this.conjunctionEditor.render()
	},

	renderConsequencesEditor: function() {
		// for tests
		if (!this.options.consequencesEditorCreator) return

		let consequences = this.options.statement?.consequences ?? []
		this.consequencesEditor = this.options.consequencesEditorCreator?.(consequences)
		this.$('.consequences-container').append(this.consequencesEditor?.el)
		this.consequencesEditor?.render()
	},

	/**
	 * @return {ConditionalStatement}
	 */
	readFromDom: function() {
		let fromDom = this.conjunctionEditor.readFromDom()
		fromDom.consequences = this.consequencesEditor.readFromDom()
		return fromDom
	},

	test: function() {
		return this.conjunctionEditor?.test?.() ??
			this.consequencesEditor?.test?.()
	},

	autoRemove: true

})

export default ConditionalStatementEditor

ConditionalStatementEditor.__filename__ = 'components/logic/conditional-statement-editor.js'
